var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FF4728"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30139 6.87925C7.04333 6.68777 6.67711 6.70904 6.44308 6.94308C6.18564 7.20051 6.18564 7.61789 6.44308 7.87533L9.06775 10.5L6.44308 13.1247C6.18564 13.3821 6.18564 13.7995 6.44308 14.0569C6.67711 14.291 7.04333 14.3122 7.30139 14.1208L7.37533 14.0569L10 11.4323L12.6247 14.0569L12.6986 14.1208C12.9567 14.3122 13.3229 14.291 13.5569 14.0569C13.8144 13.7995 13.8144 13.3821 13.5569 13.1247L10.9323 10.5L13.5569 7.87533C13.8144 7.61789 13.8144 7.20051 13.5569 6.94308C13.3229 6.70904 12.9567 6.68777 12.6986 6.87925L12.6247 6.94308L10 9.56775L7.37533 6.94308L7.30139 6.87925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCheck);
export default __webpack_public_path__ + "static/media/cancel-check.b8be5fa5e0cb3eb764b4b1530808be83.svg";
export { ForwardRef as ReactComponent };